import { Toaster as Sonner } from "sonner"

export { toast } from "sonner"

export function Toaster() {
  return <Sonner position="top-right" richColors closeButton />
}